import PrimarySearchAppBar from "../components/UI/Appbar/Appbar";
import PermanentDrawerLeft from "../components/UI/SideBar/SideBar";
import AppBody from "../components/UI/Body/Body";
import { useTheme, useMediaQuery } from "@mui/material";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../store/ui-slice";

const DashboardPage = () => {
  // const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const dispatch = useDispatch();
  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  React.useEffect(() => {
    !isMediumScreen
      ? dispatch(uiActions.setShowDrawer(true))
      : dispatch(uiActions.setShowDrawer(false));
  }, [isMediumScreen,dispatch]);

  return (
    <>
      {!isSmallScreen && <PermanentDrawerLeft />}

      <PrimarySearchAppBar>
        {isSmallScreen && <PermanentDrawerLeft />}

        <AppBody />
      </PrimarySearchAppBar>
    </>
  );
};

export default DashboardPage;
